export default "__VITE_ASSET__C0DmW1OH__"